module.exports = __webpack_public_path__ + "img/pic3_1.e6ada54b.png";